import { useState } from "react";
import { api } from "pages/api/services/baseurl";
import toast from "react-hot-toast";
import { AxiosError } from "axios";
import classNames from "classnames";
import { getUserToken } from "utils/helpers";
import { useUserContextDispatch, useUserContextState } from "@contexts/User";
import Timer from "./Timer";
import Button from "./Button";
import OTP from "./Otp";
import { AccountType } from "utils/customTypes";
import { useRouter } from "next/router";
import { useSWRConfig } from "swr";

const ConfirmOTP = ({
  setStep,
  isVerification,
}: {
  setStep: (v: number) => void;
  isVerification?: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [otpValue, setOtpValue] = useState("");
  const [min] = useState("180");
  const [done, setDone] = useState(false);
  const token = getUserToken();
  const user = useUserContextState();
  const setUser = useUserContextDispatch();
  const router = useRouter();
  const { mutate } = useSWRConfig();
  const onSubmit = async () => {
    if (isVerification) {
      if (setUser) {
        setUser((state) => ({ ...state, code: otpValue }));
      }
      return setStep(2);
    }
    if (isLoading) return;
    setIsLoading(true);
    if (!token) return setStep(1);
    try {
      const response = await api.post<{ message: string }>("/verify-account", {
        otp: otpValue,
      });
      await mutate("/profile");
      setIsLoading(false);
      toast.success(response.data.message);
      if (user.data?.account_type === AccountType.Student) {
        return router.push("/dashboard");
      }
      // setStep(2);
      return router.push("/register/complete-signup");
    } catch (err) {
      const error = err as AxiosError;
      setIsLoading(false);
      if (error.response?.status === 400) return toast.error("Invalid OTP");
      toast.error("Something went wrong");
    }
  };
  return (
    <div>
      <OTP
        {...{
          value: otpValue,
          onChange: setOtpValue,
        }}
      />
      <div>
        <Button
          label={
            isLoading ? <div className="loading">Confirming</div> : "Confirm"
          }
          onClick={onSubmit}
          className="otp-btn-spacing offset-left"
          disabled={otpValue.length !== 5}
        />
      </div>
      {!isVerification && (
        <div className="timer-cont">
          You can{" "}
          <a
            onClick={async (e) => {
              e.preventDefault();
              if (token && user) {
                try {
                  const res = await api.post<{
                    message: string;
                    data: object;
                  }>("/resend-code", { email: user?.data?.email });
                  toast.success(res.data.message);
                  setDone(false);
                  setIsDisabled(true);
                } catch (error) {
                  const err = error as AxiosError;
                  console.log(err);
                  toast.error("something went wrong sending otp");
                }
              }
            }}
            className={classNames({
              "text-disabled": isDisabled,
            })}
          >
            resend
          </a>{" "}
          in{" "}
          {done ? (
            "00:00"
          ) : (
            <Timer
              delayResend={min}
              action={() => {
                setIsDisabled(false);
                setDone(true);
              }}
            />
          )}{" "}
        </div>
      )}
    </div>
  );
};

export default ConfirmOTP;
